import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// События лендинга /kredity-new

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS_LANDING;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventShowLandingPage = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: 'Показ лендинга',
  eventValue: undefined,
});

export const eventOnClickChangeLocation = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: 'Изменение города',
  eventValue: undefined,
});

export const eventOnContinueButton = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: 'Продолжить',
  eventValue: undefined,
});

export const eventOnClickFillManuallyButton = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: 'Заполнить вручную',
  eventValue: undefined,
});

export const eventOnClickGosuslugiButton = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: 'Кнопка Войти через Госуслуги',
  eventValue: undefined,
});

export const eventOnClickOfferCard = (bankName: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Карточка банка|${bankName}`,
  eventValue: undefined,
});

export const eventOnSubmitOffer = (bankName: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Перейти на сайт|${bankName}`,
  eventValue: undefined,
});

export const eventOnChangeFilter = (filterName: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Условия от банков|${filterName}`,
  eventValue: undefined,
});

export const eventOnShowCard = ({
  calcId,
  id,
  organizationId,
  organizationName,
  offerName,
}: {
  calcId: string;
  id: string;
  organizationId: string;
  organizationName: string;
  offerName: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Просмотр предложения',
  eventLabel: `${calcId}|${id}|${organizationId}|${organizationName}|${offerName}`,
  eventValue: undefined,
});
